module.exports = __webpack_public_path__ + "img/home.93184e98.jpg";